/**
 * Read API bearer token from localStorage; ignore missing / literal "null".
 */
export function getValidAuthToken() {
  const token = localStorage.getItem("AUTH_TOKEN");
  if (!token || token === "null" || token === "undefined") {
    return null;
  }
  return token;
}

export function clearAuthStorage() {
  localStorage.removeItem("AUTH_TOKEN");
  localStorage.removeItem("ROLE_ID");
}
